import { request, type ApiFetch, type ApiResult } from './client.ts'

// Typed client for the API-keys read behind the credentials screen.
//
// The shape is transcribed from the service's `surfaces/rest/keys.ts` for the
// same reason webhooks.ts transcribes its shapes: importing back from
// `@curri/integrations-service` is a Rush cycle.
//
// Why this exists instead of the GraphQL `userApiKeys` the docs playground
// prefills from: that resolver hands a Bearer caller the sandbox key only —
// deliberately, so a sandbox credential can never be traded up for the
// production one. The portal's session is a Bearer token, so the production key
// has to come from this endpoint, whose `credential:read` scope only the
// portal's own OAuth client registers.

export const CREDENTIAL_READ_SCOPE = 'credential:read'

/** The user the keys belong to — also the username half of the Basic credential. */
export interface KeyOwner {
  userId: number
  externalId: string | null
  emailAddress: string | null
  name: string | null
}

export interface AccountKeys {
  owner: KeyOwner
  /** Null when the account has no keys, or the session may not see this one. */
  apiKey: string | null
  /** Null when the account has no sandbox key. */
  sandboxKey: string | null
}

export const fetchAccountKeys = (
  apiFetch: ApiFetch,
  signal: AbortSignal
): Promise<ApiResult<AccountKeys>> =>
  request(apiFetch, '/api/keys', { signal }, CREDENTIAL_READ_SCOPE)
